export const translations = {
  en: {
    'nav.transactions':       'Transactions',
    'nav.referral_system':    'Referral System',
    'referral.title':         'Referral System',
    'referral.description':   'Track customer referrals and affiliate campaign performance.',
    'referral.total':         'Total Referrals',
    'referral.rewarded':      'Rewarded',
    'referral.pending':       'Pending',
    'referral.top_referrers': 'Top Referrers',
    'referral.no_referrers':  'No referrers yet.',
    'referral.user_code':     'User Code',
    'referral.referral_count':'Referrals',
    'referral.referral_url':  'Referral URL',
    'transactions.title': 'Transactions',
    'transactions.subtitle':
      'Audit trail for earned, redeemed, adjusted, refunded, and expired balances.',
    'transactions.refresh': 'Refresh',
    'transactions.search': 'Search',
    'transactions.searchPlaceholder': 'Customer, phone, reference',
    'transactions.range': 'Range',
    'transactions.type': 'Type',
    'transactions.source': 'Source',
    'transactions.campaignId': 'Campaign ID',
    'transactions.optional': 'Optional',
    'transactions.allTime': 'All time',
    'transactions.today': 'Today',
    'transactions.sevenDays': '7 days',
    'transactions.thirtyDays': '30 days',
    'transactions.ninetyDays': '90 days',
    'transactions.oneYear': '1 year',
    'transactions.allTypes': 'All types',
    'transactions.allSources': 'All sources',
    'transactions.showing': 'Showing {filtered} of {total} transactions',
    'transactions.emptyTitle': 'No transactions found',
    'transactions.emptyBody':
      'Try changing the filters or run a new earn, redeem, refund, or adjustment flow.',
    'transactions.loadError': 'Unable to load transactions',
    'transactions.unknownCustomer': 'Unknown customer',
    'transactions.headers.date': 'Date',
    'transactions.headers.type': 'Type',
    'transactions.headers.customer': 'Customer',
    'transactions.headers.program': 'Program',
    'transactions.headers.amount': 'Amount',
    'transactions.headers.previous': 'Previous',
    'transactions.headers.new': 'New',
    'transactions.headers.source': 'Source',
    'transactions.headers.reference': 'Reference',
    'transactions.headers.performedBy': 'Performed By',
  },
  ar: {
    'nav.transactions':       'المعاملات',
    'nav.referral_system':    'نظام الإحالة',
    'referral.title':         'نظام الإحالة',
    'referral.description':   'تتبع إحالات العملاء وأداء الحملات التابعة.',
    'referral.total':         'إجمالي الإحالات',
    'referral.rewarded':      'تمت المكافأة',
    'referral.pending':       'قيد الانتظار',
    'referral.top_referrers': 'أعلى المحيلين',
    'referral.no_referrers':  'لا يوجد محيلون حتى الآن.',
    'referral.user_code':     'رمز المستخدم',
    'referral.referral_count':'الإحالات',
    'referral.referral_url':  'رابط الإحالة',
    'transactions.title': 'المعاملات',
    'transactions.subtitle':
      'سجل تدقيق للأرصدة المكتسبة والمستردة والمعدلة والمردودة والمنتهية.',
    'transactions.refresh': 'تحديث',
    'transactions.search': 'بحث',
    'transactions.searchPlaceholder': 'العميل أو الهاتف أو المرجع',
    'transactions.range': 'النطاق',
    'transactions.type': 'النوع',
    'transactions.source': 'المصدر',
    'transactions.campaignId': 'معرف الحملة',
    'transactions.optional': 'اختياري',
    'transactions.allTime': 'كل الوقت',
    'transactions.today': 'اليوم',
    'transactions.sevenDays': '7 أيام',
    'transactions.thirtyDays': '30 يومًا',
    'transactions.ninetyDays': '90 يومًا',
    'transactions.oneYear': 'سنة واحدة',
    'transactions.allTypes': 'كل الأنواع',
    'transactions.allSources': 'كل المصادر',
    'transactions.showing': 'عرض {filtered} من {total} معاملة',
    'transactions.emptyTitle': 'لم يتم العثور على معاملات',
    'transactions.emptyBody':
      'جرّب تغيير عوامل التصفية أو نفّذ عملية كسب أو استرداد أو رد أو تعديل جديدة.',
    'transactions.loadError': 'تعذر تحميل المعاملات',
    'transactions.unknownCustomer': 'عميل غير معروف',
    'transactions.headers.date': 'التاريخ',
    'transactions.headers.type': 'النوع',
    'transactions.headers.customer': 'العميل',
    'transactions.headers.program': 'البرنامج',
    'transactions.headers.amount': 'المبلغ',
    'transactions.headers.previous': 'السابق',
    'transactions.headers.new': 'الجديد',
    'transactions.headers.source': 'المصدر',
    'transactions.headers.reference': 'المرجع',
    'transactions.headers.performedBy': 'نفذ بواسطة',
  },
}

export const supportedLocales = ['en', 'ar']
